export default "__VITE_ASSET__Bicw56Px__"